import React, { FC } from "react";
import { FormItemsProps, FormRowsRenderer } from "./FormRowsRenderer";

interface Props {
  props: FormItemsProps;
}

export const FormCompanyItems: FC<Props> = ({ props }) => {
  return (
    <form
      className={`table w-full bg-white md:rounded-lg border-spacing-0 space-y-6 ${
        props.isBorder === false ? "" : "border border-theme-light"
      }`}
    >
      <FormRowsRenderer props={props} />
    </form>
  );
};
